module.exports = __webpack_public_path__ + "img/symbol_10.a9087159.png";